import { render, staticRenderFns } from "./AllPatients.vue?vue&type=template&id=3056e11a&"
import script from "./AllPatients.vue?vue&type=script&lang=js&"
export * from "./AllPatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports